export default "__VITE_ASSET__CMRSgLAK__"